import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-multi-button-renderer',
  templateUrl: './multi-button-renderer.component.html',
})
export class MultiButtonRendererComponent implements ICellRendererAngularComp {
  params: any;
  buttons: any[] = [];

  agInit(params: any): void {
    this.params = params;
    this.buttons = this.params.value || [];
  }

  refresh(params: any): boolean {
    this.params = params;
    this.buttons = this.params.value || [];
    return true;
  }

  handleButtonClick(button: any): void {
    if (button.action) {
      button.action(this.params.node.data);
    }
  }
}
